module.exports = __webpack_public_path__ + "static/assets/e1f65050fa6a3f6b432c593f79661da1.gif";